export const passwordCheckers = [
  {
    label: "At least 10 characters",
    check: (val: string) => val.length >= 10,
  },
  {
    label: "At least one uppercase letter",
    check: (val: string) => /[A-Z]/.test(val),
  },
  {
    label: "At least one lowercase letter",
    check: (val: string) => /[a-z]/.test(val),
  },
  {
    label: "At least one number",
    check: (val: string) => /\d/.test(val),
  },
  {
    label: "At least one special character",
    check: (val: string) => /[^A-Za-z0-9\s]/.test(val),
  },
];
